<template>
  <div class="invite-report">
    <!-- 搜索框 -->
    <searchBar @search="search" :checkList="checkList" @reload="fetchData" />

    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      :span-method="arraySpanMethod"
      :row-class-name="tableRowClassName"
      height="660"
    >
      <el-table-column label="用户ID" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="登录类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="用户类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="微信昵称" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="openID" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="推荐人" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="首次登录时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="最后登录时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="登录次数统计" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName || '--' }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
      ref="Pagination"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />
  </div>
</template>

<script>
import { getIntroduceReportListApi } from '@/api/introduce';
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import searchBar from './components/searchBar'; // 搜索框
import { dateFormate } from '@/utils/dateFormate';
import { decrypt } from '@/utils/encryp';
export default {
  components: {
    Pagination,
    searchBar,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      detailShow: false,
      pageSize: 0,
      pageIndex: 1,
      totalCount: 0,
      path: '',
      detailObj: {}, // 详情数据
      checkList: [], // 选中的列表
      defaultDateTime: [],
    };
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    this.defaultDateTime = [dateFormate(start), dateFormate(end)];
    this.fetchData();
  },
  mounted() {
    document.querySelector('.el-table__body-wrapper').style.height = '580px';
  },
  computed: {
    ...mapGetters(['paginObj']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    // paginObj: 'fetchData',
  },
  methods: {
    // 处理解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },
    // 合并列
    arraySpanMethod({ rowIndex, columnIndex }) {
      let len = this.list.length - 1;
      let currentPage = len < this.pageSize ? len : this.pageSize;
      if (rowIndex === currentPage) {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 3,
          };
        } else if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 0,
          };
        } else if (columnIndex === 2) {
          return {
            rowspan: 1,
            colspan: 0,
          };
        }
      }
    },
    // 最后一行的背景颜色
    tableRowClassName({ rowIndex }) {
      if (rowIndex === this.list.length - 1) {
        return 'total-row';
      }
      return '';
    },
    // 请求表单数据
    async fetchData() {
      try {
        this.listLoading = true;
        let res = await getIntroduceReportListApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          startTime: this.defaultDateTime[0],
          endTime: this.defaultDateTime[1],
          ...this.fromSearchObj,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.totalCount = totalCount;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },

    // 搜索
    search(obj = {}) {
      if (obj) this.fromSearchObj = obj;
      this.fetchData();
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.appFailRecordId;
      });
    },

    // 页面变化
    handleCurrentChange(obj) {
      this.paginObj.pageIndex = obj.pageIndex;
      this.fetchData();
    },
    // 分页改变页面数据
    handleSizeChange(obj) {
      this.paginObj.pageIndex = 1;
      this.paginObj.pageSize = obj.pageSize;
      this.fetchData();
    },
  },
};
</script>

<style lang="less">
.visit {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.btn {
  margin-bottom: 10px;
}

.lookDetails {
  margin-top: 10px;
}

.detail {
  .detail-row {
    margin-top: 10px;
    display: flex;
    font-size: 16px;

    span {
      width: 100px;
      text-align: right;
      margin-right: 20px;
      font-weight: 550;
    }
  }
}
</style>
